export const carousel_images = [{ file_name: 'samsung-z-flip.jpg' }]

export const carousel_images_mobile = [{ file_name: 'samsung-z-flip.jpg' }]

export const carousel_path = '/assets/images/hero/'

export const stores = [
    {
        store_name: 'Makarim Two Rivers SES',
        store_location: 'Two Rivers, Ruaka',
        contact: '0728566889',
        lat: -1.211447,
        lng: 36.79497,
    },
    {
        store_name: 'Galaxy Accessories & Mobile - Sarit',
        store_location: 'Karuna Road, Westlands',
        contact: '0722910808',
        lat: 1.2612,
        lng: 36.8021,
    },
    {
        store_name: 'Tricom Village Market',
        store_location: 'Limuru road, Ruaka',
        contact: '0722610474',
        lat: -1.228126,
        lng: 36.805791,
    },
    {
        store_name: 'Samsung Delite SES',
        store_location: 'Banda street, ICEA Building',
        contact: '0728170000',
        lat: -1.28688,
        lng: 36.818045,
    },
    {
        store_name: 'Galleria Brand Shop',
        store_location: 'Galleria, Karen',
        contact: '0706521523',
        lat: -1.211447,
        lng: 36.79497,
    },
    {
        store_name: 'Dream Collection',
        store_location: 'Diamond Plaza, Parklands',
        contact: '0725247475',
        lat: -1.258317,
        lng: 36.81912,
    },
    {
        store_name: 'Galaxy Mobiles & Accessories',
        store_location: 'Ciata city, Kiambu Road',
        contact: '0704252354',
        lat: -1.225652,
        lng: 36.83843,
    },
    {
        store_name: 'Fine Com Ltd (Digo Rd)',
        store_location: 'Digo road, Mombasa',
        contact: '0715410490',
        lat: -4.070472,
        lng: 39.672569,
    },
    {
        store_name: 'Fine Com Ltd (Nyali)',
        store_location: 'Nyali, Mombasa',
        contact: '0722412929',
        lat: -1.211447,
        lng: 36.79497,
    },
    {
        store_name: 'Avi communication',
        store_location: 'Kenyatta Avenue, Sarova Stanley',
        contact: '0726019739',
        lat: -1.284274,
        lng: 36.822691,
    },
    {
        store_name: 'PhoneLink',
        store_location: 'TRM, Thika Road',
        contact: '0771848993',
        lat: -1.21985,
        lng: 36.889022,
    },
    {
        store_name: 'Phone Link',
        store_location: 'Westgate, Westlands',
        contact: '0771915559',
        lat: -1.256937,
        lng: 36.803439,
    },
    {
        store_name: 'Galaxy 4 Garden City',
        store_location: 'Garden City, Thika Road',
        contact: '0786778954',
        lat: -1.232516,
        lng: 36.878564,
    },
    {
        store_name: 'Pana Music',
        store_location: 'Western,Eldoret Town',
        contact: '0712133135',
        lat: 0.516303,
        lng: 35.27499,
    },
    {
        store_name: 'Devi stationers',
        store_location: 'Kenyatta Avenue, Nakuru',
        contact: '',
        lat: 0.516303,
        lng: 35.27499,
    },
    {
        store_name: 'Kenshop SES',
        store_location: 'Westside Mall, Nyanza',
        contact: '0720637733',
        lat: 0.0999,
        lng: 34.7508,
    },
    {
        store_name: 'Ropem Kitengela',
        store_location: 'Kitengela Mall, Kitengela ',
        contact: '',
        lat: -1.4754633,
        lng: 36.9598562,
    },
    {
        store_name: 'Dipcomm',
        store_location: 'Mountain, Meru town',
        contact: '',
        lat: 0.0515,
        lng: 37.6456,
    },
    {
        store_name: 'Nakuru SES',
        store_location: 'Westend Mall, Nakuru',
        contact: '',
        lat: 0.3031,
        lng: 36.08,
    },
]
export const samsung_stores = [
    {
        store_name: 'Galaxy Hub',
        store_location: 'Nairobi',
        contact: '0723266309',
        lat: -1.211447,
        lng: 36.79497,
    },
    {
        store_name: 'Jaicom Galleria ',
        store_location: 'Nairobi',
        contact: '0720950110',
        lat: -1.211447,
        lng: 36.79497,
    },
    {
        store_name: 'Nairobi Galaxy Water Front',
        store_location: 'Nairobi',
        contact: '0717202737',
        lat: 1.2612,
        lng: 36.8021,
    },
    {
        store_name: 'Mombasa County Connections',
        store_location: 'Mombasa',
        contact: '0704515057',
        lat: 1.2612,
        lng: 36.8021,
    },
    {
        store_name: 'Nairobi Galaxy Garden City',
        store_location: 'Nairobi',
        contact: '0701791085',
        lat: -1.228126,
        lng: 36.805791,
    },
    {
        store_name: 'Meru Bright Pharmacy',
        store_location: 'Meru',
        contact: '0700912969',
        lat: -1.228126,
        lng: 36.805791,
    },
    {
        store_name: ' Machakos Image Connection',
        store_location: 'Machakos',
        contact: '0719379255',
        lat: -1.228126,
        lng: 36.805791,
    },
    {
        store_name: 'Nairobi TRM SES',
        store_location: 'Nairobi',
        contact: '0725054171',
        lat: -1.228126,
        lng: 36.805791,
    },
    {
        store_name: 'Nairobi Westgate SES',
        store_location: 'Nairobi',
        contact: '0720573999',
        lat: -1.228126,
        lng: 36.805791,
    },
    {
        store_name: 'Nairobi Junction SES',
        store_location: 'Nairobi',
        contact: '0729897126',
        lat: -1.228126,
        lng: 36.805791,
    },
    {
        store_name: 'Galaxy Accessories & Mobile - Sarit',
        store_location: 'Karuna Road, Westlands',
        contact: '0724062609',
        lat: 1.2612,
        lng: 36.8021,
    },
    {
        store_name: 'Jaicom Imara Mall',
        store_location: 'Nairobi, Msa Road',
        contact: '0711887688',
        lat: -1.228126,
        lng: 36.805791,
    },
    {
        store_name: 'Jaicom Mega',
        store_location: 'Nairobi, Msa Road',
        contact: '0716490845',
        lat: -1.228126,
        lng: 36.805791,
    },
    {
        store_name: 'Tricom Village Market',
        store_location: 'Limuru road, Ruaka',
        contact: '0726875150',
        lat: -1.228126,
        lng: 36.805791,
    },

    {
        store_name: 'Fine Com Ltd (Digo Rd)',
        store_location: 'Digo road, Mombasa',
        contact: '0707986932',
        lat: -4.070472,
        lng: 39.672569,
    },
    {
        store_name: 'Fine Com Ltd (Nyali)',
        store_location: 'Nyali, Mombasa',
        contact: '0727650762',
        lat: -1.211447,
        lng: 36.79497,
    },

    {
        store_name: 'Pana Music',
        store_location: 'Western,Eldoret Town',
        contact: '0717634736',
        lat: 0.516303,
        lng: 35.27499,
    },
    {
        store_name: 'Devi stationers',
        store_location: 'Kenyatta Avenue, Nakuru',
        contact: '0739787875',
        lat: 0.516303,
        lng: 35.27499,
    },
    {
        store_name: 'Kenshop SES',
        store_location: 'Westside Mall, Kisumu',
        contact: '0700601993',
        lat: 0.0999,
        lng: 34.7508,
    },
    {
        store_name: 'Ropem Kitengela',
        store_location: 'Kitengela Mall, Kitengela ',
        contact: '0724817827',
        lat: -1.4754633,
        lng: 36.9598562,
    },
]
export const retailStores = [
    {
        store_name: 'Chiromo Court',
        store_location: '2nd Floor, Waiyaki Way',
        contact: '0725626262',
        // lat: -1.211447,
        // lng: 36.79497,
    },
    {
        store_name: 'Badili Store',
        store_location: 'Ambience Mall, RingRoad, Westlands',
        contact: '0725626262',
        // lat: 1.2612,
        // lng: 36.8021,
    },
]
